import { css, cx } from '@emotion/css';
import styled from '@emotion/styled';
import { Space, SpaceProps } from 'antd';
import Currency from './Currency';
import FormatNumber, { FormatNumberProps } from './FormatNumber';

export interface PriceProps extends SpaceProps {
  value: number;
  format?: FormatNumberProps['format'];
  currency?: General.Currency;
  type?: 'total' | 'normal';
  currencyClassName?: string;
}

const Wrapper = styled(Space)``;
const CurrencyText = styled.i`
  font-style: normal;
  text-align: center;
`;
const styles = {
  totalPrice: css`
    color: #ff7b15;
    font-size: 24px;
  `,
  totalCurrency: css`
    font-size: 18px;
    color: #ff7b15;
  `,
};
const Price = (props: PriceProps) => {
  const {
    value,
    format = '0,0.00',
    type = 'total',
    currency,
    currencyClassName,
    className,
    ...otherProps
  } = props;
  return (
    <Wrapper
      align="center"
      className={cx(className, { [styles.totalPrice]: type === 'total' })}
      {...otherProps}
    >
      <FormatNumber number={value} format={format} />
      {currency ? (
        <CurrencyText
          className={cx(currencyClassName, { [styles.totalCurrency]: type === 'total' })}
        >
          <Currency value={currency} />
        </CurrencyText>
      ) : null}
    </Wrapper>
  );
};
export default Price;
